import axiosInstance from "../axios/axiosInstance";
import AuthorizationService from "./AuthorizationService";
import config from "./Config";
import RoleService from "./RoleService";

export default class PagamentoService {

    async listAllPagamentos(iss, dataInicio, dataFim) {
        const accessLevel = AuthorizationService.getResourceAccessLevel('financeiro');
        const idPrestador = RoleService.getPrestador();

        switch (accessLevel) {
            case 'GLOBAL':
                return this.listAllPagamento(iss, dataInicio, dataFim);
            case 'COMPANY':
                return this.listAllPagamento(iss, dataInicio, dataFim);
            case 'SELF':
                return this.listAllPagamentoByPrestador(iss, idPrestador, dataInicio, dataFim);
            default:
                throw new Error('Acesso não autorizado');
        }
    }

    /// PAGAMENTO ///
    listAllPagamento(data, dataInicio, dataFim) {
        var params = {
            dataInicio: dataInicio,
            dataFim: dataFim
        }

        return axiosInstance.get(`${config.api.version}/pagamento/${data}/get`, {
            params: params
        })
    }

    listAllPagamentoByPrestador(data, prestadorId, dataInicio, dataFim) {
        var params = {
            dataInicio: dataInicio,
            dataFim: dataFim,
            join: true
        }

        return axiosInstance.get(`${config.api.version}/pagamento/${data}/get?agendamentos.prestadorTipoAgendamento.prestador.user.id=${prestadorId}`, { params: params })
    }

    listResumoTaxas(data, params) {
        return axiosInstance.get(`${config.api.version}/financeiro/${data}/get`, {
            params
        })
    }

    getPagamento(data, id) {
        var params = { all: true }
        return axiosInstance.get(`${config.api.version}/pagamento/${data}/get/${id}`, {
            params: params
        })
    }



    getPagamentoFilter(data, companyId, prestadorId, dataInicio, dataFim) {
        var params = {
            dataInicio: dataInicio,
            dataFim: dataFim
        }
        if (companyId)
            return axiosInstance.get(`${config.api.version}/pagamento/${data}/get`, { params: params })

        if (prestadorId)
            return axiosInstance.get(`${config.api.version}/pagamento/${data}/get?agendamentos.agendaPrestador.prestador.id=${prestadorId}&join=true&dataInicio=${dataInicio}&dataFim=${dataFim}`)

        return axiosInstance.get(`${config.api.version}/pagamento/${data}/get?dataInicio=${dataInicio}&dataFim=${dataFim}`)
    }

    postPagamento(data, pagamento) {
        return axiosInstance.post(`${config.api.version}/pagamento/${data}/`, pagamento)
    }

    putPagamento(data, pagamento, id) {
        return axiosInstance.put(`${config.api.version}/pagamento/${data}/${id}`, pagamento)
    }

}